module.exports = __webpack_public_path__ + "img/pdf.94c33c1c.svg";